<div class="skl-pods" aria-busy="true" aria-label="Loading pods list">
  <div class="skl-header">
    <app-skeleton width="180px" height="24px" borderRadius="4px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-card skl-card--form">
    <div class="skl-card__body">
      <app-skeleton width="120px" height="18px" borderRadius="4px" marginBottom="20px"></app-skeleton>
      <div class="skl-form-grid">
        <div>
          <app-skeleton width="80px" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="100%" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div>
          <app-skeleton width="80px" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="120px" height="20px" borderRadius="10px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-form-grid__action">
          <app-skeleton width="100%" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      </div>
    </div>
  </div>

  <app-pods-list-table-skeleton></app-pods-list-table-skeleton>
</div>